
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyCanCube as ObiBuoyCanCubeElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-can-cube.js';
 
 
 

 
 export const ObiBuoyCanCube = createComponent({
   react: React,
   tagName: 'obi-buoy-can-cube',
   elementClass: ObiBuoyCanCubeElement,
   events: {
     
   }
  });
 
 